<template>
	<article class="iv2-article">
		<transition mode="out-in" :name="animation">
			<div v-if="pageActive">
				<Error403 v-if="items.open_type == 0" />

				<div v-else-if="items.open_type == 1">
					<LayoutTitle :items="items" />
					<LayoutPattern :items="items" />
				</div>
			</div>
		</transition>

		<div v-if="loading">
			<BaseLoading />
		</div>
	</article>
</template>

<script>
import LayoutTitle from "./components/LayoutTitle.vue";
import LayoutPattern from "./components/LayoutPattern.vue";
import BaseLoading from "@/components/items/BaseLoading.vue";

import Error403 from "@/components/systems/Page403.vue";

import Meta from "@/mixins/MetaSettable";
import Hash from "@/mixins/AnchorLink";
import Preview from "@/mixins/Preview";

export default {
	mixins: [Meta, Hash, Preview],

	props: ["animation"],

	components: {
		LayoutTitle,
		LayoutPattern,
		BaseLoading,
		Error403,
	},

	data() {
		return {
			items: [],
			loading: true,
			pageActive: false
		};
	},

	mounted() {
		this.load()
	},

	methods: {
		load() {
			if(this.$route.query.mode == 'preview') {
				this.axios.get('/preview/pages' + this.$route.path + '/show', {
					headers: {
						Authorization: `Bearer ${this.$cookies.get('preview-token')}`,
					}
				}).then((response) => {
					this.items = response.data.response;
					this.loading = false;
					this.pageActive = true;
				}).catch(() => {
					this.loading = false;
					this.pageActive = true;
				});
			}else{
				this.axios.get('/pages' + this.$route.path + '/show').then((response) => {
					this.items = response.data.response;
					this.loading = false;
					this.pageActive = true;
				}).catch(() => {
					this.loading = false;
					this.pageActive = true;
				});
			}
		},
	},

	watch: {
		$route: function (to, from) {
			if (to.path !== from.path) {
				this.loading = true;
				this.pageActive = false;
				this.load()
			}
		},
	},
};
</script>

<style lang="scss">
</style>
